import axios from 'axios';
import { isArray, merge } from 'lodash';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import userACL from '../../../store/access';
import { getHeaderJWT, URL } from '../../../store/path';
import { handlError, parseError } from '../../app/serverError';
import { fetchedArchive, savedArchive, saveArchiveEditedRes, fetchedDownloadData } from './actions';
import { getIsArchiveFetched } from './selectors';


// const delay = (ms) => new Promise(res => setTimeout(res, ms))


//#region Saga for Edit Archive 

function* editArchive() {
  yield takeEvery('EDIT_ARCHIVE', saveEditedArchive)
}

function* saveEditedArchive(action) {

  const { response, error } = yield call(editArchiveAPI, action.payload)

  if (response) {
    yield put(savedArchive(action.payload))
    yield put(saveArchiveEditedRes(action.payload))
  }
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

function editArchiveAPI(data) {
  let obj = {
    id: data.id,
    status: data.status
  }
  return axios.post(URL + '/master/Archive/update', obj, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))

}

//#endregion


//#region Saga for List Archive 

function* fetchArchive() {
  yield takeEvery('FETCH_ARCHIVE', requestArchive)
}


function* requestArchive() {
  const isArchiveFetched = yield select(getIsArchiveFetched);
  if (!isArchiveFetched) {
    let { data } = yield call(requestArchiveAPI)
    let archiveArr = [];
    if (isArray(data)) {
      let i;
      if (data.length > 0) {
        for (i = 0; i < data.length; i++) {
          try {
            let archiveObj = { name: data[i].split("/")[1], link: data[i] };
            archiveArr = [...archiveArr, archiveObj]
          } catch (e) {
            continue;
          }
        }
      }
      yield put(fetchedArchive(archiveArr))
    }
  }
}


function requestArchiveAPI(data) {
  data = merge({}, data, userACL.atFetch())
  data.pg = localStorage.getItem('acc')
  return axios.post(URL + '/report/dms-txns/arcdata', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion

/* DOWNLOAD ZIP START  */
// FETCH_DOWNLOAD_DATA
function* fetchArchiveData() {
  yield takeEvery('FETCH_DOWNLOAD_ARCHIVE', requestArchiveData)
}

function* requestArchiveData(action) {
  try {
    const response = yield call(
      downloadingZipData,
      action.payload,
      action.payload1
    );
    // 🟡 JSON response from backend
    if (response && response.type === "json") {
      const { status, message, estimated_time } = response.data;
      put(fetchedDownloadData(message));
      // or dispatch redux action
      // yield put(showArchiveMessage(response.data))
    }
    // 🟢 File downloaded automatically
  } catch (err) {
    console.error("Download failed", err);
  }
}

function downloadingZipData(data, payload1) {
  return new Promise((resolve, reject) => {
    const xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
      if (this.readyState !== 4) return;

      const contentType = xhttp.getResponseHeader("Content-Type") || "";

      // ❌ API error
      if (this.status !== 200) {
        reject({ status: this.status });
        return;
      }

      // 🟢 CASE 1: Backend sent JSON (restore / archived message)
      if (contentType.includes("application/json")) {
        const text = new TextDecoder("utf-8").decode(xhttp.response);
        const json = JSON.parse(text);

        resolve({ type: "json", data: json });

        setTimeout(() => payload1(false), 600);
        return;
      }

      // 🟢 CASE 2: Backend sent ZIP file
      const blob = new Blob([xhttp.response], {
        type: "application/zip",
      });

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      document.body.appendChild(a);
      a.style.display = "none";
      a.href = downloadUrl;
      a.download = `file.zip`;
      a.click();

      window.URL.revokeObjectURL(downloadUrl);
      payload1(false);

      resolve({ type: "file" });
    };

    xhttp.open(
      "GET",
      URL + "/report/dms-txns/download_zip/" + data,
      true
    );

    xhttp.setRequestHeader(
      "X-RLB-DMS-ACC",
      localStorage.getItem("acc")
    );
    xhttp.setRequestHeader(
      "Authorization",
      `Bearer ${localStorage.getItem("user")}`
    );

    xhttp.responseType = "arraybuffer";
    xhttp.send();
  });
}

/* DOWNLOAD ZIP END  */



const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* ArchiveSaga() {
  yield all([
    fetchArchive(),
    // editArchive(),
    fetchArchiveData(),
  ])
}  